






























import { MessagesFilterButton } from '@/types/components/Button.interface'
import Vue from 'vue'
export default Vue.extend({
    computed: {
        items(): MessagesFilterButton[] {
            return [
                {
                    tooltip: 'Show Messages & Comments',
                    type: 'channel',
                    color: 'primary',
                    outlined: true,
                    callback: () => (this.messageType = 'channel')
                },
                {
                    tooltip: 'Show Messages',
                    type: 'send',
                    color: 'primary',
                    outlined: true,
                    callback: () => (this.messageType = 'send')
                },
                {
                    tooltip: 'Show Scheduled',
                    type: 'scheduled',
                    color: 'primary',
                    outlined: true,
                    callback: () => (this.messageType = 'scheduled')
                },
                {
                    tooltip: 'Show Comments',
                    type: 'comment',
                    color: 'primary',
                    outlined: true,
                    callback: () => (this.messageType = 'comment')
                },
                {
                    tooltip: 'Show Events',
                    type: 'event',
                    color: 'primary',
                    outlined: true,
                    callback: () => (this.messageType = 'event')
                }
            ]
        },
        //  The 'show scheduled' toggle in the messages panel
        messageType: {
            get(): string {
                return this.$store.getters.inboxMessageType
            },
            set(val: string): void {
                //  Update the store
                this.$store.commit('inboxMessageTypeSet', val)
            }
        }
    },
    methods: {
        isActive(item: MessagesFilterButton): boolean {
            //  Grab the item type
            const type = item.type

            //  If the item type matches our message type, return true
            return type === this.messageType
        }
    }
})
